import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const saveBulkFulfillmentView = {
  name: "saveBulkFulfillmentView" as const,
  input: z.object({ view: viewSchemas["bulk-fulfillments"] }),
  output: z.object({}),
};
